import type { ISitemapLocation } from "~/types/kentico/sitemaps";

interface ISitemapMatcherOptions {
	sitemap: ISitemapLocation[] | null;
	routeFilterOptions: any;
	caseSensitive?: boolean;
}

export function sitemapMatcher({ sitemap, routeFilterOptions, caseSensitive = false }: ISitemapMatcherOptions): ISitemapLocation | undefined {
	if (!sitemap || !routeFilterOptions.A) return;
	return sitemap?.find((sitemapLocation: any) => {
		return Object.keys(routeFilterOptions).every((key) => {
			if (typeof routeFilterOptions[key] === "function") {
				if (routeFilterOptions[key] !== null) {
					return routeFilterOptions[key](sitemapLocation[key]);
				}
			}
			return (
				(caseSensitive ? sitemapLocation[key] : sitemapLocation[key]?.toLowerCase()) ===
				(caseSensitive ? routeFilterOptions[key] : routeFilterOptions[key] ? routeFilterOptions[key].toLowerCase() : sitemapLocation[key])
			);
		});
	});
}
